"use client";

/* Texte FR : apostrophes/typographie non échappées volontairement (règles cosmétiques). */
/* eslint-disable react/no-unescaped-entities, react/jsx-one-expression-per-line */

import { FC, FormEvent, useState } from "react";
import axios from "axios";
import * as SC from "./EssaiGratuitPage.style";

export const EssaiGratuitPage: FC = () => {
  const [companyName, setCompanyName] = useState("");
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [done, setDone] = useState(false);

  const handleSubmit = async (e: FormEvent) => {
    e.preventDefault();
    if (!companyName.trim() || !name.trim() || !email.trim()) {
      setError("Merci de renseigner tous les champs.");
      return;
    }
    setSubmitting(true);
    setError(null);
    try {
      await axios.post("/api/user/self-signup", {
        companyName: companyName.trim(),
        name: name.trim(),
        email: email.trim(),
      });
      setDone(true);
    } catch (err: any) {
      const status = err.response?.status;
      setError(
        status === 409
          ? "Un compte existe déjà avec cet email."
          : "Une erreur est survenue. Réessayez dans un instant.",
      );
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <SC.Page>
      <SC.Card>
        <SC.Brand>Wibat</SC.Brand>

        {done ? (
          <>
            <SC.SuccessIcon>📧</SC.SuccessIcon>
            <SC.Title>Vérifiez votre email</SC.Title>
            <SC.SuccessText>
              Nous avons envoyé un lien d'activation à
              {" "}
              <strong>{email}</strong>
              .
              Cliquez dessus pour définir votre mot de passe et démarrer vos
              <strong> 14 jours d'essai gratuit</strong>
              .
            </SC.SuccessText>
          </>
        ) : (
          <>
            <SC.Title>Essai gratuit — 14 jours</SC.Title>
            <SC.Subtitle>
              Accès complet, sans engagement. Aucune carte bancaire requise.
            </SC.Subtitle>

            {error && <SC.Error>{error}</SC.Error>}

            <form onSubmit={handleSubmit}>
              <SC.Field>
                <SC.Label htmlFor="companyName">Nom de l'entreprise</SC.Label>
                <SC.Input
                  id="companyName"
                  value={companyName}
                  onChange={(e) => setCompanyName(e.target.value)}
                  placeholder="Ex : Dupont Rénovation"
                  autoComplete="organization"
                />
              </SC.Field>
              <SC.Field>
                <SC.Label htmlFor="name">Votre nom</SC.Label>
                <SC.Input
                  id="name"
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                  placeholder="Ex : Jean Dupont"
                  autoComplete="name"
                />
              </SC.Field>
              <SC.Field>
                <SC.Label htmlFor="email">Email professionnel</SC.Label>
                <SC.Input
                  id="email"
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="vous@entreprise.fr"
                  autoComplete="email"
                />
              </SC.Field>

              <SC.SubmitButton type="submit" disabled={submitting}>
                {submitting ? "Création..." : "Démarrer l'essai gratuit"}
              </SC.SubmitButton>
            </form>

            <SC.Legal>
              En créant un compte, vous acceptez les conditions d'utilisation de Wibat.
            </SC.Legal>
          </>
        )}
      </SC.Card>
    </SC.Page>
  );
};

export default EssaiGratuitPage;
